import { format } from "date-fns";

/**
 * Frontend display formatting for performance screens (`dd/MM/yyyy`, time, combined local strings).
 * Not for API payloads — use {@link toISOString} when sending date-time to the backend.
 */
export function formatDateLocal(date: Date | string): string {
  return format(new Date(date), "dd/MM/yyyy");
}

export function formatTimeLocal(time: string): string {
  return format(time, "HH:mm:ss");
}

export function formatDateTimeLocal(date: Date | string): string {
  return format(new Date(date), "dd/MM/yyyy HH:mm:ss");
}

/** Serialize a `Date` for request bodies when sending date-time values to the API/backend (ISO 8601). */
export function toISOString(date: Date): string {
  return date.toISOString();
}
